import React, { ReactNode } from 'react'
import styled from 'styled-components'

interface Props {
  children: ReactNode
}

export function DisabledMessage({ children }: Props) {
  return <Container>{children}</Container>
}

const Container = styled.div`
  padding: 0 20px 20px 20px;
  min-height: 400px;
`
